import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostRecentPostsConfig = {
    title: 'chart.facebook.widget_most_recent_posts',
    id: 'widget_most_recent_posts',
    size: SIZE_FULL,
    sortFields: [
        'created',
        'engagement_rate',
        'engagement_on_reach',
        'shares',
        'reach',
        'clicks',
        'impressions_views'
    ],
    type: 'widget',
    element: MediasWidget
};
